var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loaded)?_c('div',{staticClass:"loader"},[_c('div',[_vm._v("Loading")]),_c('div',[_vm._v(_vm._s(_vm.dots))])]):_vm._e(),(_vm.loaded)?_c('div',[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }